// extracted by mini-css-extract-plugin
module.exports = {"container":"IncidentList_container__JqXki","heading":"IncidentList_heading__9b2ik","top":"IncidentList_top__3tnvc"};